import { getProjectSiteAri } from '@atlassian/projects-goals-common/get-app-site-ari';
import type { PreloadedQuery } from 'react-relay';

import type { RelayResourceConfig } from '@townsquare/relay-utils';
import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { RouteResource } from '@townsquare/router/resources/types';
import type {
	ResourceStoreContext,
	RouterContext,
	RouterDataContext,
} from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';

import GoalsDirectoryAggOuterQuery, {
	type GoalsDirectoryAggOuterQuery as GoalsDirectoryAggOuterQueryType,
} from '../components/__generated__/GoalsDirectoryAggOuterQuery.graphql';

export const getGoalDirectoryAggResourceQuery = (
	_routerContext: RouterContext | RouterDataContext,
	resourceContext: ResourceStoreContext,
): RelayResourceConfig<GoalsDirectoryAggOuterQueryType> => {
	const context = resourceContext as ResourceContext;
	const cloudId = context.workspace?.cloudId;

	if (!cloudId) {
		throw new Error('goalDirectoryAggResource: no cloudId available on resource context');
	}

	// `customFieldContainerId` feeds `projects_customFieldDefinitionSearch`, so this takes the
	// project-owned site ARI even though this is the goals directory.
	const containerId = getProjectSiteAri(cloudId);
	return {
		environment: getAggRelayEnvironment(),
		query: GoalsDirectoryAggOuterQuery,
		variables: {
			customFieldContainerId: containerId,
			workspaceUuid: context.workspace?.UUID,
		},
	};
};

export const goalDirectoryAggResource: RouteResource<
	PreloadedQuery<GoalsDirectoryAggOuterQueryType, Record<string, unknown>>
> = createRelayResource<GoalsDirectoryAggOuterQueryType>({
	getQuery: getGoalDirectoryAggResourceQuery,
});
